/* istanbul ignore next */
// TypeScript can't resolve the import for ax/icon, but Webpack is properly configured to handle it
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Icon from 'ax/icon';
import { enableMapSet } from 'immer';
import PageContainer from 'page/container';
import { IS_DEVELOPMENT } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { registerLoadEvent } from '~/modules/services/metricsService';
import { contentStore } from '~/modules/stores/contentStore';
import { i18nStore } from '~/modules/stores/i18nStore';
import { wordPressStore } from '~/modules/stores/wordpress_store';
import { SUPPORTED_LANGUAGES } from '~/modules/utilities/language_utils';
import { listingStore } from './modules/stores/listingStore';
import { logger } from './modules/utilities/logger';

// Configure immer to support maps in stores
enableMapSet();

// Set default path for our icons svg
Icon.defaultSpriteUrl = '/images/icons.svg';

/* Map toJSON implementation to see maps in REDUX_DEV_TOOLS */
if (IS_DEVELOPMENT) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (Map.prototype as any).toJSON = function () {
        return JSON.parse(JSON.stringify([...this]));
    };
}

// Initialize i18n
const language = getUserLanguage();
if (i18nStore.getState().currentLanguage !== language && SUPPORTED_LANGUAGES.includes(language)) {
    i18nStore.setLanguage(language);
}

// Hydrate shared stores
if (window.stores?.LISTING) {
    const { listing, listingId } = window.stores.LISTING;
    if (listing && listingId) {
        listingStore.upsertListing(listingId, listing);
    }
}

if (window.stores?.WORDPRESS) {
    wordPressStore.setState(window.stores.WORDPRESS);
}

if (window.stores?.HOME_CONTENT) {
    contentStore.setHomeContent(window.stores.HOME_CONTENT);
}

if (!customElements.get('page-container')) {
    customElements.define('page-container', PageContainer.CustomElementConstructor);
}

registerLoadEvent();

try {
    // eslint-disable-next-line @lwc/lwc/no-document-query
    const main = document.querySelector('#main');
    if (!main) {
        throw new Error("Failed to find element with id 'main'");
    }
    main.appendChild(document.createElement('page-container'));
} catch (error) {
    logger.error(`Failed to setup main page ${error}`);
}
